const REST_API_URL = process.env.REACT_APP_TEST_REST_API_URL;
const REST_API_URL_V2 = process.env.REACT_APP_TEST_REST_API_URL_V2;
const ROOT_HOST = process.env.REACT_APP_ROOT_HOST;

export { ROOT_HOST, REST_API_URL, REST_API_URL_V2 };
